import { mapGetters, mapMutations, mapActions } from 'vuex';

import MediaUpload from '@/components/media/upload';

const upload = {
    components: {
        MediaUpload,
    },
    computed: {
        ...mapGetters({
            files: 'getMediaUploadModalItems',
        }),
        uploadButtonText() {
            let text = '';
            if (this.currentView === 'MediaSelect') {
                text = '<i class="fa fa-upload"></i> Upload new';
            } else {
                text = '<i class="fa fa-th"></i> Media Gallery';
            }
            return text;
        },
        uploadModalOptions() {
            const uploadModalOptions = {};

            // Check if strategy has own method
            if (!this.options.upload.onProcessFile) {
                uploadModalOptions.onProcessFile = this.onProcessFile;
            }

            if (this.options.upload.multiple) {
                uploadModalOptions.allowMultiple = this.options.upload.multiple;
            }

            if (this.options.upload.allowedTypes) {
                uploadModalOptions.allowedFileTypes = this.options.upload.allowedTypes;
            }

            return uploadModalOptions;
        },
    },
    methods: {
        ...mapActions({
            prependItem: 'prependGalleryMediaSelectItem',
            showMediaUpload: 'showMediaUpload',
        }),
        showUploadModal() {
            this.$store.dispatch('showMediaUploadModal', this.uploadModalOptions);
        },
        toggleUpload() {
            this.showMediaUpload(this.uploadModalOptions);
        },
        onProcessFile(file) {
            return new Promise((resolve, reject) => {
                const serverData = JSON.parse(file.serverId).data;

                this.prependItem({
                    id: serverData.id,
                    title: serverData.title,
                    status: serverData.status,
                    url: file.getFileEncodeDataURL(),
                    type: serverData.type,
                    created_at: serverData.created_at,
                    metadata: {},
                }).then(() => {
                    // single mode return to gallery view and select item
                    if (!this.options.upload.multiple) {
                        this.setCurrentView('MediaSelect');
                    }
                    resolve(serverData);
                });
            }).catch((error) => {
                console.log(error);
            });
        },
    },
};

export default upload;
